import { addDatatoCartApi, fetchCartDetails, updateCartQuantity } from '../../../../utils/cartSlice'

export const handleAddToCart = async (e, productDetails, dispatch) => {
	e.preventDefault()
	//Add Data to cart api first
	const cartItemForApi = {
		productId: productDetails?._id,
		productType: productDetails.productType,
		categoryTypeId: productDetails?.categoryType?._id || productDetails?.categoryTypeId || productDetails?.productDataType?._id,
		quantity: 1,
		productCategoryType:
			productDetails?.categoryTypeName || productDetails?.categoryType?.categoryTypeName || productDetails?.productDataType?.categoryTypeName,
	}
	const res = await dispatch(addDatatoCartApi(cartItemForApi))
	if (res?.payload?.status === 1) {
		await dispatch(fetchCartDetails())
	}
}

export const handleCartQuantityChange = async (id, dispatch, quantity) => {
	// Ensure the action is valid ('increase' or 'decrease')

	const body = {
		productId: id,
		quantity: quantity,
	}
	const res = await dispatch(updateCartQuantity(body))
	if (res?.payload?.status === 1) {
		await dispatch(fetchCartDetails())
	}
}
